module.exports = __webpack_public_path__ + "static/img/ha.aae7176b.png";